<draft-editor [draft]="draft" [draftSpecial]="special" [enableChangeSpecial]="true"></draft-editor>
